import { GET_BRANCH_CMS } from '../type'

const initialState = {
  listBranch: [],
}

const branch = (state = initialState, action) => {
  switch (action.type) {
    case GET_BRANCH_CMS:
      return {
        ...state,
        listBranch: action.data,
      }
    default:
      return state
  }
}

export default branch
